// extracted by mini-css-extract-plugin
export default {"featuresMenu":"featuresMenu__hg+p+","multichannel":"multichannel__VeY8v"};